export default __webpack_public_path__ + "static/SRI 3200 - Product Specifications & Technical Data-e7b7e77ee2c6401d36ae1aa3d05cd6bf.pdf";